export const CUSTOMER = 'Customer';
export const specialCharacterRegex = /[`~!@#$%^&*()\-_+=\[\]{}\\|;:'",<>./?]/;
export const numberRegex = /\d/;
export const uppercaseRegex = /[A-Z]/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const urlRegex = /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
export const ngnRegistrationNumberRegex = /^(RC|BN)-[0-9]{7}$/;
